import { useState } from "react"
import { MARKETPLACE } from "@acc/shared"
import { SHOP_IDENT } from "../../app/reducers/settingsReducer"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { useAppSelector } from "../../app/hooks"
import { selectShopsStore } from "../../app/reducers/shopsSlice"
import { getMessage } from "../../msgs/msgs"
import { selectFeedShopsStore } from "../../app/reducers/feedShopsSlice"
import { TextField, Button } from "@radix-ui/themes"
import { Select } from "../Select/Select"

const options = [
  { value: MARKETPLACE.WB, label: "Wildberries" },
  { value: MARKETPLACE.OZON, label: "Озон" },
  { value: MARKETPLACE.YANDEX, label: "Яндекс маркет" },
  { value: SHOP_IDENT.SAMSON, label: "Самсон ОПТ" },
]

export const TokenManager = () => {
  const [selectedService, setSelectedService] = useState<
    MARKETPLACE | SHOP_IDENT.SAMSON | ""
  >("")
  const [token, setToken] = useState<string>("")
  const [additionalToken, setAdditionalToken] = useState<string>("")
  const shops = useAppSelector(selectShopsStore)
  const feedShops = useAppSelector(selectFeedShopsStore) || []

  const saveToken = async (
    marketplace: MARKETPLACE | SHOP_IDENT.SAMSON,
    token: string,
    subToken?: string,
  ) => {
    try {
      const resp = await BaseApi.setToken(marketplace, { token, subToken })
      NotificationService.showNotification({
        level: resp.data?.success ? "success" : "error",
        message: resp.data?.message || "Токен успешно сохранен",
      })
      setToken("")
      setAdditionalToken("")
    } catch (error: any) {
      NotificationService.showNotification({
        level: "error",
        message:
          error.response?.data?.message || "Ошибка при сохранении токена",
      })
    }
  }

  return (
    <div
      style={{ padding: "20px 0", height: "100%" }}
      className="flex flex-column flex-align-center flex-justify-between gap-20"
    >
      <div style={{ width: "50%" }} className="flex flex-column">
        <Select
          value={selectedService}
          onChange={(value) => {
            setSelectedService(value as any)
          }}
          options={[
            ...options.map((option) => ({
              value: option.value,
              label: option.label,
            })),
            ...Object.keys(shops || {})
              .filter((key) => shops[key]?.updateType === "api")
              .map((key) => ({ value: key, label: getMessage(key) })),
            ...Object.keys(feedShops || {})
              .filter((key) => feedShops[key]?.authFieldIdent)
              .map((key) => ({
                value: feedShops[key]?.authFieldIdent ?? key,
                label: getMessage(key),
              })),
          ]}
          placeholder="Выбрать сервис"
          clearable
        />
        <div>
          <TextField.Root
            size="3"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            type="text"
            placeholder="Введите токен"
          />
          {selectedService === MARKETPLACE.OZON && (
            <TextField.Root
              size="3"
              value={additionalToken}
              onChange={(e) => setAdditionalToken(e.target.value)}
              type="text"
              placeholder="Введите дополнительный токен"
            />
          )}
        </div>
      </div>
      <Button
        disabled={
          !selectedService ||
          !token ||
          (selectedService === MARKETPLACE.OZON && !additionalToken)
        }
        onClick={() =>
          selectedService && saveToken(selectedService, token, additionalToken)
        }
      >
        Сохранить токен
      </Button>
    </div>
  )
}
